import React from 'react';
import SelectButtons, { SelectButtonProps } from '../components/SelectButtons';
import BackToTopButton from '@/shared/components/BackToTopButton';
import { useScrollToTop } from '@/shared/hooks/useScrollToTop';
import { View } from 'react-native';
import MissingStyleSupportText from '../components/MissingStyleSupportText';
import styled from '@emotion/native';

type Props = Omit<SelectButtonProps, 'fieldTitle'>;

const SelectPreferences = ({
  setSelectedItems,
  selectedItems,
  enumArray,
  showDescription = false,
}: Props) => {
  const scrollToTop = useScrollToTop();
  return (
    <>
      <SelectButtons
        fieldTitle="Styling Preferences"
        setSelectedItems={setSelectedItems}
        selectedItems={selectedItems}
        enumArray={enumArray}
        showDescription={showDescription}
      />
      {showDescription && (
        <BottomContainer>
          <MissingStyleSupportText
            style={{ width: 200, textAlign: 'center' }}
          />
          <View style={{ height: 41, width: '100%' }} />
          <BackToTopButton scrollToTop={scrollToTop} />
        </BottomContainer>
      )}
    </>
  );
};

const BottomContainer = styled.View({
  flex: 1,
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginTop: 20,
});

export default SelectPreferences;
